
//import image3 from "../../../Components/Header/Gallery/3.jpg";
import image4 from "./4.jpg";
import image5 from "./5.jpg";
import image6 from "./6.jpg";
import image7 from "./7.jpg";
import image8 from "./8.jpg";
import image9 from "./team 3.jpg";





export const skillsData = [
 
  
    // { name: '', image: image3 },
    { name: '', image: image4 },
    { name: '', image: image5 },
    { name: '', image: image6 },
    { name: '', image: image7 },
    { name: '', image: image8 },
    {name:"Certificates issued to the Team", image:image9}
    

];

